import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const getTotalCaseCount = (analytics) => (analytics?.rows || []).reduce(
    (acc, row) => acc + (row.case_count || 0),
    0,
);

const getDayCount = (startDate, endDate) => {
    if (!startDate || !endDate) {
        return 0;
    }

    return endDate.clone().startOf('day').diff(startDate.clone().startOf('day'), 'days') + 1;
};

const formatAverage = (value) => value.toFixed(1);

function DailyAverageKpi({ analytics, endDate, startDate }) {
    const rows = analytics?.rows || [];
    const totalCaseCount = getTotalCaseCount(analytics);
    const dayCount = getDayCount(startDate, endDate);
    const average = dayCount > 0 ? totalCaseCount / dayCount : 0;
    const hasData = rows.length > 0;

    return (
        <section className="dashboard-kpi-card">
            <div className="dashboard-chart-header dashboard-chart-header--with-icon">
                <h2>Daily Average</h2>
                <Tooltip title="Average submitted scans per day across the selected date range.">
                    <InfoOutlinedIcon className="dashboard-chart-info-icon" fontSize="small" />
                </Tooltip>
            </div>
            <div className="dashboard-kpi-card__body">
                {hasData ? (
                    <>
                        <div className="dashboard-kpi-card__value">
                            {formatAverage(average)}
                        </div>
                        <div className="dashboard-kpi-card__label">Cases / Day</div>
                    </>
                ) : (
                    <div className="dashboard-kpi-card__empty">No data</div>
                )}
            </div>
        </section>
    );
}

DailyAverageKpi.propTypes = {
    analytics: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({
            case_count: PropTypes.number,
        })),
    }),
    endDate: PropTypes.shape({}).isRequired,
    startDate: PropTypes.shape({}).isRequired,
};

DailyAverageKpi.defaultProps = {
    analytics: null,
};

export default DailyAverageKpi;
